import _implicitStylesheets from "./panels.css";

import _implicitScopedStylesheets from "./panels.scoped.css?scoped=true";

import {registerTemplate} from "lwc";
function tmpl($api, $cmp, $slotset, $ctx) {
  const {k: api_key, d: api_dynamic_text, t: api_text, h: api_element, i: api_iterator} = $api;
  return [api_element("select", {
    classMap: {
      "slds-select": true,
      "panel-select": true
    },
    styleDecls: [["width", "auto", false]],
    key: 0
  }, api_iterator($cmp.panelList, function (p, i) {
    return api_element("option", {
      attrs: {
        "value": p.key
      },
      key: api_key(1, p.key)
    }, [api_text(api_dynamic_text(p.value))]);
  }))];
}
export default registerTemplate(tmpl);
tmpl.stylesheets = [];


if (_implicitStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitStylesheets)
}
if (_implicitScopedStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitScopedStylesheets)
}
tmpl.stylesheetToken = "zpaper-panels_panels"
